if (window.location.pathname.includes("/apps/customer-portal")) {
  setTimeout(()=>{
    const menuContainer = document.querySelector(".Polaris-Navigation__PrimaryNavigation");
    
    if (menuContainer) {
      const menuSections = document.querySelectorAll(".bss-menu-navigation-section");
    
      if (menuSections && menuSections.length >= 2) {
        const secondMenuSection = menuSections[1];
    
        const newMenuSection = document.createElement("div");
        newMenuSection.classList.add("bss-menu-navigation-section");
    
        const menuItems = [
             { name: "SKU Lookup", link: "/pages/sku-lookup" },
          { name: "Upload Order", link: "/pages/upload-order" },
         // { name: "Promotions", link: "/pages/promotions" },
          { name: "Invoices", link: "/pages/invoices" },
          { name: "Shipments", link: "/pages/shipments" },
        ];
    
        const menuContent = document.createElement("div");
        menuContent.classList.add("Polaris-Box");
        menuContent.style.cssText =
          "--pc-box-padding-block-end-xs: var(--p-space-5); --pc-box-padding-block-start-xs: var(--p-space-5); --pc-box-padding-inline-start-xs: var(--p-space-8); --pc-box-padding-inline-end-xs: var(--p-space-8); --pc-box-width: 100%;";
    
        const menuStack = document.createElement("div");
        menuStack.classList.add("Polaris-VerticalStack");
        menuStack.style.cssText =
          "--pc-vertical-stack-order: column; --pc-vertical-stack-gap-xs: var(--p-space-2);";
    
        menuItems.forEach((item) => {
          const menuItem = document.createElement("div");
          menuItem.classList.add("bss-menu-navigation-section-btn");
    
          menuItem.innerHTML = `
            <div class="Polaris-HorizontalStack" style="--pc-horizontal-stack-align: space-between; --pc-horizontal-stack-wrap: wrap;">
              <div class="Polaris-HorizontalStack" style="--pc-horizontal-stack-wrap: wrap; --pc-horizontal-stack-gap-xs: var(--p-space-2);">
    
                <a href="${item.link}" class="Polaris-Text--root Polaris-Text--bodyMd" style="text-decoration: none; color: inherit;" target="_self">
                  ${item.name}
                </a>
              </div>
              <div class="arrow-icon">
                <span class="Polaris-Icon Polaris-Icon--colorBase Polaris-Icon--applyColor">
                  <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                    <path d="m17.707 9.293-5-5a.999.999 0 1 0-1.414 1.414l3.293 3.293h-11.586a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414z"></path>
                  </svg>
                </span>
              </div>
            </div>
          `;
    
          menuStack.appendChild(menuItem);
        });
    
        menuContent.appendChild(menuStack);
        newMenuSection.appendChild(menuContent);
    
        secondMenuSection.insertAdjacentElement("afterend", newMenuSection);
      }
    }
  },2000)
}

